import { useTranslation } from 'react-i18next';
import withScroll from '@/hoc/withScroll';
import { UpdatedDate } from '@/components/LoanTerms/UpdatedDate';
import { RepaymentSchedule } from './components/RepaymentSchedule';
import { LoanPlans } from './components/LoanPlans';
import { RiskFactor } from './components/RiskFactor';
import { LAST_UPDATED } from './constants';
import s from './index.module.scss';

const LoanTermsVersion05 = ({ plan }) => {
  const { t } = useTranslation('plans-v5');

  return (
    <div className={s.page}>
      <div className="container-inner">
        <div className={s.content}>
          <div className={s.main}>
            <h1 className="f-hero-h2">{t('page.title')}</h1>
            <LoanPlans plan={plan} />
            <RiskFactor plan={plan} />
          </div>

          <div className={s.row}>
            <div className="f-hero-h4">{t('plans.understanding_risk_factor_scoring')}</div>
            <div className="f-body-regular">
              <div>{t('plans.risk_assessment')}</div>
              <div style={{ marginTop: '16px' }}>{t('plans.risk_factors')}</div>
              <div>{t('plans.low_risk_focus')}</div>
            </div>
          </div>

          <div className={s.row}>
            <div className="f-hero-h4">{t('plans.loan_repayments')}</div>
            <div className="f-body-regular">
              <div>{t('plans.investor_reliance')}</div>
              <div style={{ marginTop: '16px' }}>{t('plans.repayment_schedule')}</div>
            </div>
          </div>

          <div className={s.row}>
            <div className="f-hero-h4">{t('plans.regular_repayment_schedule')}</div>
            <div className="f-body-regular">
              <div>{t('plans.flat_fee')}</div>
              <div>{t('plans.monthly_repayments')}</div>
              <div>{t('plans.final_repayment')}</div>
              <div>{t('plans.early_repayment')}</div>
            </div>
          </div>

          <RepaymentSchedule plan={plan} />

          <div className={s.row}>
            <div className="f-hero-h4">{t('plans.loan_agreements')}</div>
            <div>
              <div className={s.box}>
                <div className="f-body-regular">
                  <div>{t('plans.financing_agreements')}</div>
                  <div>{t('plans.agreement_signing')}</div>
                </div>
              </div>
            </div>
          </div>
          <UpdatedDate date={LAST_UPDATED} />
        </div>
      </div>
    </div>
  );
};

export default withScroll(LoanTermsVersion05);
